import { Typography, TextField, Button, Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { Container } from './styles'
import React, { useState, useEffect } from 'react'
import api from '../../config/api'
import { useHistory, useParams } from 'react-router-dom'

function UpdateUnity() {

    const [description, setDescription] = useState('')
    const [oldDescription, setOldDescription] = useState('')

    const [openSuccess, setOpenSuccess] = useState(false);
    const [openFailed, setOpenFailed] = useState(false);
    const [errorMessage, setErrorMessage] = useState("Erro desconhecido");

    //@ts-ignore
    const { id } = useParams()

    useEffect(() => {
        async function fetch() {

            const response = await api.get(`/unitys/${id}`)

            const { description } = response.data.unity
            setDescription(description)
            setOldDescription(description)
        }
        fetch()

    }, [])


    const handleCloseSuccess = (event?: React.SyntheticEvent, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSuccess(false);
        history.push('/unitys')
    };

    const handleCloseFailed = (event?: React.SyntheticEvent, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenFailed(false);
    };

    let history = useHistory();


    function handleDescription(e: React.ChangeEvent<HTMLInputElement>) {
        setDescription(e.target.value)
    }


    async function handleSubmit() {

        try {
            if (description.trim().length === 0)
                throw new Error("Missing field")

            const response = await api.put(`/unitys/${id}`, {
                description
            })


            if (response.status === 200) {
                setOpenSuccess(true)
            }
        } catch (err) {
            if(err instanceof Error){
                if (err.message === "Missing field") {
                    setOpenFailed(true)
                    setErrorMessage('Digite todos os campos')
                }
                else if (err.message === "Unity already cadastred") {
                    setOpenFailed(true)
                    setErrorMessage('Esta unidade já está cadastrado')
                }
            }
             else {
                setOpenFailed(true)
                setErrorMessage('Erro desconhecido')
            }
        }
    }



    return (
        <Container>
            <div className="form">
                <Typography variant="h4" style={{ marginBottom: 10, fontWeight: 600 }}>
                    Atualizar unidade de medida: {oldDescription}
                </Typography>

                <TextField
                    className="text-bar"
                    value={description}
                    label="Digite a descrição da unidade"
                    variant="outlined"
                    onChange={handleDescription}
                />
                <Button variant="contained" color="secondary" className="submit-button" onClick={handleSubmit}>
                    Atualizar
                 </Button>
            </div>
            <Snackbar open={openSuccess} autoHideDuration={500} onClose={handleCloseSuccess}>
                <Alert onClose={handleCloseSuccess} severity="success">
                    Unidade de medida atualizada com sucesso!
                </Alert>
            </Snackbar>

            <Snackbar open={openFailed} autoHideDuration={2000} onClose={handleCloseFailed}>
                <Alert onClose={handleCloseFailed} severity="error">
                    {errorMessage}
                </Alert>
            </Snackbar>

        </Container>
    );
}

export default UpdateUnity